module.exports = __webpack_public_path__ + "static/media/joao-paulo-nogueira.d08e1f6e.webp";